module.exports = __webpack_public_path__ + "media/images/529s/favicon-e280bbb18fbafcff560c512f42cdf8db.ico";